import React, { ReactElement } from 'react';

import ToolbarPopupTool from '../../../ToolbarPopupTool';
import LabelsToolbarPopup from './LabelsToolbarPopup';

import { ImMNElement } from '../../../../../../../common/elements/elementModelTypes';
import { PopupIds } from '../../../../../../components/popupPanel/popupConstants';

type Props = {
    selectedElements: Immutable.List<ImMNElement>;
    name: string;
};

const LabelTool = (props: Props): ReactElement => {
    return (
        <ToolbarPopupTool
            {...props}
            popupId={PopupIds.LABELS_TOOL}
            toolName={'Label'}
            buttonSelector=".LabelTool .icon"
            PopupComponent={LabelsToolbarPopup}
        />
    );
};

export default LabelTool;
